import BookingInfoPayment from './BookingInfoPayment'

export { BookingInfoPayment }
